import { render, staticRenderFns } from "./categories-edit.vue?vue&type=template&id=ef7032d4&scoped=true&"
import script from "./categories-edit.vue?vue&type=script&lang=js&"
export * from "./categories-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7032d4",
  null
  
)

export default component.exports